import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Icon from './icons';
import NotificationsMenu from './NotificationsMenu';
import ProfileMenu, { initials } from './ProfileMenu';

const CRUMBS = {
    '/dashboard': 'Overview',
    '/dashboard/projects': 'All projects',
    '/dashboard/new-translation': 'New project',
    '/dashboard/team': 'People',
    '/dashboard/analytics': 'Reports',
    '/dashboard/glossary': 'Translation memory',
    '/dashboard/translation-memory': 'Translation memory',
    '/dashboard/glossaries': 'Glossaries',
    '/dashboard/brand-voice': 'Brand voice',
    '/dashboard/ai-quality': 'AI quality',
    '/dashboard/apps': 'Integrations',
    '/dashboard/settings': 'Settings',
    '/dashboard/account': 'Account',
    '/dashboard/people': 'People',
    '/dashboard/preview': 'In-context preview',
    '/dashboard/help': 'Help',
    '/dashboard/reports': 'Reports',
    '/dashboard/sources': 'Connected sources',
    '/dashboard/automations': 'Automations',
    '/dashboard/inbox': 'Inbox',
    '/dashboard/queue': 'My queue',
    '/dashboard/admin': 'Admin',
};

const Topbar = () => {
    const location = useLocation();
    const user = useSelector((s) => s.auth.user) || {};
    const pathKeys = Object.keys(CRUMBS).sort((a, b) => b.length - a.length);
    const matched = pathKeys.find((k) => location.pathname.startsWith(k));
    const crumb = matched ? CRUMBS[matched] : 'Overview';
    const workspace = user.organization || user.company || 'Workspace';

    return (
        <div className="rs-topbar">
            <div className="rs-crumb">
                <span>{workspace}</span>
                <span className="sep">/</span>
                <span>Localization</span>
                <span className="sep">/</span>
                <b>{crumb}</b>
            </div>
            <div className="spacer" />
            <Link className="icon-btn" to="/dashboard/help" aria-label="Help" style={{ textDecoration: 'none' }}>
                {Icon.help}
            </Link>
            <NotificationsMenu />
            <Link className="btn-new" to="/dashboard/new-translation" style={{ textDecoration: 'none' }}>
                {Icon.plus}<span>New project</span>
            </Link>
            <ProfileMenu placement="down" trigger={() => <div className="av-top">{initials(user)}</div>} />
        </div>
    );
};

export default Topbar;
